module.exports = __webpack_public_path__ + "static/media/qr-myvnpt-ios.2f7d864b.png";